import { BetaInstructions } from '../features/instructions'

export default BetaInstructions
